import { getFunctions, httpsCallable } from 'firebase/functions';
import { app } from './firebase';

const functions = app ? getFunctions(app) : null;

export interface OrderEmailData {
  orderSummary: string;
  customerName: string;
  customerEmail: string;
  customerPhone?: string | null;
  orderId: string;
  totalAmount: number;
  shippingAddress?: string;
}

export interface EmailResult {
  businessEmailSent: boolean;
  customerEmailSent: boolean;
  errors: Array<{ type: string; message: string }>;
}

/**
 * Send order notification emails (business + customer)
 * Calls the Firebase Cloud Function to send emails via nodemailer
 */
export async function sendOrderEmails(data: OrderEmailData): Promise<EmailResult> {
  try {
    if (!functions) {
      return {
        businessEmailSent: false,
        customerEmailSent: false,
        errors: [
          {
            type: 'configuration',
            message: 'Firebase functions are not configured.',
          },
        ],
      };
    }

    console.log('📧 Calling sendOrderEmails function...');
    console.log('📧 Data:', data);

    const sendOrderEmailsFn = httpsCallable<OrderEmailData, EmailResult>(
      functions,
      'sendOrderEmails'
    );

    const result = await sendOrderEmailsFn(data);
    console.log('✅ Email function response:', result.data);

    return result.data;
  } catch (error: any) {
    console.error('❌ Error calling sendOrderEmails function:', error);

    // Return a result indicating failure
    return {
      businessEmailSent: false,
      customerEmailSent: false,
      errors: [
        {
          type: 'function_call',
          message: error.message || 'Failed to call email function'
        }
      ]
    };
  }
}

/**
 * Test email configuration
 * Sends a test email to verify the setup is working
 */
export async function sendTestEmail(): Promise<{ success: boolean; messageId?: string }> {
  try {
    if (!functions) {
      throw new Error('Firebase functions are not configured.');
    }

    console.log('🧪 Calling testEmail function...');

    const testEmailFn = httpsCallable<void, { success: boolean; messageId?: string }>(
      functions,
      'testEmail'
    );

    const result = await testEmailFn();
    console.log('✅ Test email response:', result.data);

    return result.data;
  } catch (error: any) {
    console.error('❌ Error calling testEmail function:', error);
    throw error;
  }
}
